export default __webpack_public_path__ + "static/msc-6d25733cff384cc45b654b169f8e0d2e.png";